import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  purposesLength: 0,
  purposes: [],
  purpose: {},
  purposeError: "",
  formError: "",
};

export default function PurposeReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_PURPOSE:
      return { ...state, loading: action.payload };
      
    case actions.LOADING_PURPOSE_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_PURPOSE:
      return { ...state, saveLoading: action.payload };

    case actions.GET_PURPOSE:
      return {
        ...state,
        purposes: action.payload.purposes,
        purposesLength: action.payload.purposesLength,
      };
    case actions.GET_PURPOSE_BY_ID:
      return { ...state, purpose: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.PURPOSE_FAIL:
      return { ...state, purposeError: action.payload };

    default:
      return state;
  }
}
